import { useQuery } from "@tanstack/react-query";

import { PROMOTION_CACHE_KEYS } from "./keys";

import { PromotionRepository } from "@/repositories/promotion";

const promotionRepository = new PromotionRepository();

export const useGetPromotion = (id: string | null) => {
  return useQuery({
    queryKey: PROMOTION_CACHE_KEYS.DETAIL(id ?? ""),
    queryFn: () => promotionRepository.findById(id ?? ""),
    enabled: id !== null,
  });
};
